import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { RELATIVE_TICK_POSITION } from '../timeline-constants.js';
import { getAbsolutePosition } from '../timeline-position-utils.js';
import { getSchedulerWidth } from '../timeline-utils.js';
import './timeline-timestamp.css';
function TimelineTimestamp(props) {
    const { interval, intervals } = props;
    const [actualMoment, setActualMoment] = useState(moment());
    useEffect(() => {
        let interval = null;
        if (isRunning(actualMoment)) {
            interval = window.setInterval(() => {
                setActualMoment(moment());
            }, 1000);
        }
        return () => {
            interval && window.clearInterval(interval);
        };
    }, [actualMoment]);
    useEffect(() => {
        setActualMoment(moment());
    }, []);
    const isRunning = (actualMoment) => {
        return actualMoment > intervals[0];
    };
    const position = () => {
        return getAbsolutePosition(actualMoment, interval, intervals) + RELATIVE_TICK_POSITION + 0.5;
    };
    const maxWidth = getSchedulerWidth(intervals.length) + RELATIVE_TICK_POSITION;
    if (!isRunning(actualMoment)) {
        return null;
    }
    return (React.createElement("div", { className: "c-timeline-timestamp", style: { maxWidth: `${maxWidth}rem`, width: `${position()}rem` } },
        React.createElement("div", { className: "c-timeline-timestamp__background" }),
        React.createElement("div", { className: "c-timeline__timestamp-time" },
            React.createElement("span", { className: "c-timeline__timestamp-time__text" }, actualMoment.local().format('LT')))));
}
export { TimelineTimestamp, };
//# sourceMappingURL=timeline-timestamp.js.map